import { useQuery } from "@tanstack/react-query";
import ApiClient from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

export function useUser() {
  const { data: user, isLoading } = useQuery({
    queryKey: queryKeys.auth.user(),
    queryFn: ApiClient.getMe,
  });

  return { user, isLoading };
}
